<div class="template-area__preview">
  <div class="prev-content custom-scroll-bar">
    <div class="chat-container p-2">
      <div class="chat-bubble">
        @if (type) {
          <div class="bg-light-subtle upload-container py-2 px-1">
            @if (type === "image") {
              <label for="fileUpload" class="w-100 d-block">
                <img
                  class="rounded-lg"
                  [src]="fileUrl"
                  alt="image"
                  style="width: 100%; height: 100%; object-fit: cover"
                />
              </label>
            } @else if (type === "video") {
              <label for="fileUpload" class="w-100 d-block">
                <video width="98%" height="auto" controls>
                  <source [src]="fileUrl" type="video/mp4" />
                  {{ "campaign.template.videoNotSupported" | translate }}
                </video>
              </label>
            } @else if (type === "document") {
              <label
                for="fileUpload"
                class="w-100 d-block"
                style="text-align: center"
              >
                <i
                  class="mdi mdi-file-document-outline fs-1 text-secondary"
                ></i>
                <span class="d-block text-truncate fw-semibold">{{
                  "campaign.evoTemplate.file" | translate
                }}</span>
              </label>
            }
          </div>
        }
        <p
          class="text-start p-2 text-dark fw-semibold fs-5"
          [innerHTML]="formatWhatsappMessage(inputText)"
        ></p>
      </div>
    </div>
  </div>
</div>
